function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M75 512h362c41.355 0 75-33.645 75-75V75c0-41.355-33.645-75-75-75H75C33.645 0 0 33.645 0 75v362c0 41.355 33.645 75 75 75zM30 75c0-24.813 20.188-45 45-45h362c24.813 0 45 20.188 45 45v362c0 24.813-20.188 45-45 45H75c-24.813 0-45-20.188-45-45zm0 0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M256 391c74.438 0 135-60.563 135-135s-60.563-135-135-135-135 60.563-135 135 60.563 135 135 135zm0-240c57.898 0 105 47.102 105 105s-47.102 105-105 105-105-47.102-105-105 47.102-105 105-105zm0 0M406 151c24.813 0 45-20.188 45-45s-20.188-45-45-45-45 20.188-45 45 20.188 45 45 45zm0-60c8.27 0 15 6.73 15 15s-6.73 15-15 15-15-6.73-15-15 6.73-15 15-15zm0 0"
});

function SvgIconInstagramOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2);
}

export default SvgIconInstagramOutline;